import {useEffect, useLayoutEffect, useState} from "react";
import {dataFetch, getItem, getUrl, loadCss, setPrice} from "./lib";
import {setTrack} from "./tracking";
import {useNavigate} from "react-router-dom";
import {BookEnum} from "../_business";
import {useTranslation} from "react-i18next";

export const useBook = ({nextUrl, trackEvent = 'book', landing = null} = {}) => {
  const
    {i18n} = useTranslation(),
    navigate = useNavigate()

  // const {catchError} = usePayment({force: true})

  const
    price = getItem('price', null, window.sessionStorage),
    [state, setState] = useState({
      price,
      load: !price?.[BookEnum.ultimate]?.name
    })

  useLayoutEffect(() => {
    loadCss(`/static/css/${landing ? landing + '/' : ''}Paywall.css`)
  }, [])

  useEffect(() => {
    if (!window._uid && !window.localStorage.getItem('uid')) {
      navigate(getUrl('/'))
      return
    } else if (!state.price) {
      navigate(nextUrl)
      return
    } else {
      const url = `${process.env.REACT_APP_API_URI}web-payments/prices?lang=${i18n.resolvedLanguage}&uid=${window._uid || window.localStorage.getItem('uid')}`
      dataFetch(
        url,
        {},
        (response) => {
          for (const item of response) {
            if (+item.id === +state.price.id) {
              setPrice(item)
              setState({
                price: item,
                load: false,
              })

              return
            }
          }

          setState(prev => ({...prev, load: false}))
        },
        'GET',
        (r) => {
          // catchError(r, `useBook plan fetch ${url}`, false, false)
          navigate(nextUrl)
        }
      )

      // fetch(
      //   `${process.env.REACT_APP_API_URI}mp/${uid}`,
      //   {
      //     method: 'POST',
      //     // headers: {
      //     //   'Content-Type': 'application/json',
      //     // },
      //     body: JSON.stringify({})
      //   }
      // )
      //   .then(() => {})
    }

    setTrack(trackEvent)

    window.localStorage.setItem('success', '1')
  }, [])

  return state
}